/**
 * settings-shared — 系统设置各二级页共用的小件（拆页后从原 SettingsPage 抽出，避免每页各拷一份）。
 * 仅纯展示组件 + 常量，无数据/状态。
 */

import type { ReactNode } from 'react';
import { Icons } from '~/lib/icons';

/** NOT-in-scope 控件统一禁用 title（指向计划 §五）*/
export const NOT_IN_SCOPE_TITLE =
  '本轮 NOT-in-scope（dev-docs 无对应端点，见 docs/plans/2026-06-12-web-real-api-integration-plan.md §五）';

/** NOT-in-scope 区块统一提示条（warn 软底）*/
export function NotInScopeNotice({ text }: { text: string }) {
  return (
    <div
      className="hstack"
      style={{
        gap: 8,
        padding: 12,
        background: 'var(--warn-soft)',
        borderRadius: 6,
        fontSize: 11.5,
        color: 'var(--fg-muted)',
        lineHeight: 1.55,
      }}
    >
      <Icons.IconAlert size={13} style={{ color: 'var(--warn)', flexShrink: 0, marginTop: 1 }} />
      {text}
    </div>
  );
}

/** 二级页区块标题（title + 可选 sub + 右侧 action）*/
export function SectionHead({
  title,
  sub,
  action,
}: { title: ReactNode; sub?: ReactNode; action?: ReactNode }) {
  return (
    <div className="hstack" style={{ alignItems: 'flex-end' }}>
      <div style={{ flex: 1 }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, letterSpacing: '-0.01em' }}>
          {title}
        </h2>
        {sub && <div style={{ fontSize: 12, color: 'var(--fg-muted)', marginTop: 2 }}>{sub}</div>}
      </div>
      {action}
    </div>
  );
}
